import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { get } from "lodash";

import { queryClient } from "App";
import UserService from "services/User";
import { PRODUCTS_TABLE_CONSTANTS } from "routes/product/products_table/ProductsTableV3";
import ProductService from "services/Product";
import {
  getProductsTableColumns,
  getProductsTableFilters,
} from "routes/product/products_table/ProductsTableColumnsAndFilters";
import { addResizedColumns } from "./useTableConfig";

export const invalidateProductsQuery = async () => {
  await queryClient.invalidateQueries({
    queryKey: [PRODUCTS_TABLE_CONSTANTS.queryKey],
  });
};

export const deleteProduct = async id => {
  await ProductService.delete(id);
  await invalidateProductsQuery();
};

export const useProductsTable = () => {
  const { data: tableSettings, isSuccess: isTableSettingsFetched } = useQuery({
    queryKey: ["table-settings"],
    queryFn: UserService.getUserSettings,
  });

  const columns = useMemo(() => {
    if (!isTableSettingsFetched) return [];
    const initialColumns = getProductsTableColumns();
    const productsTableSettings = get(
      tableSettings,
      `user_settings.preferences.tables.${PRODUCTS_TABLE_CONSTANTS.tableName}`,
      {}
    );
    const withResizedColumns = addResizedColumns({
      columns: initialColumns,
      resizedColumns: productsTableSettings?.resized_columns || {},
    });
    return withResizedColumns;
  }, [tableSettings, isTableSettingsFetched]);

  const filters = useMemo(() => getProductsTableFilters(), []);

  return { columns, filters };
};
